import { DS_PROGRESS_BAR_VARIANT, type DSProgressBarVariant } from "../types/variant";

export const DS_PROGRESS_BAR_CLASSES = {
  Root: "ds-progress-bar",
  Track: "ds-progress-bar__track",
  Indicator: "ds-progress-bar__indicator",
  VariantPrimary: "ds-progress-bar--primary",
  VariantSecondary: "ds-progress-bar--secondary",
  VariantSuccess: "ds-progress-bar--success",
  VariantDanger: "ds-progress-bar--danger",
  VariantInfo: "ds-progress-bar--info",
  Revert: "ds-progress-bar--revert",
} as const;

export const DS_PROGRESS_BAR_VARIANT_TO_CLASS_MAP: Record<DSProgressBarVariant, string> = {
  [DS_PROGRESS_BAR_VARIANT.Primary]: DS_PROGRESS_BAR_CLASSES.VariantPrimary,
  [DS_PROGRESS_BAR_VARIANT.Secondary]: DS_PROGRESS_BAR_CLASSES.VariantSecondary,
  [DS_PROGRESS_BAR_VARIANT.Success]: DS_PROGRESS_BAR_CLASSES.VariantSuccess,
  [DS_PROGRESS_BAR_VARIANT.Danger]: DS_PROGRESS_BAR_CLASSES.VariantDanger,
  [DS_PROGRESS_BAR_VARIANT.Info]: DS_PROGRESS_BAR_CLASSES.VariantInfo,
} as const;
